import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import {
  ManagerMediaListResponseSchema,
  ManagerMediaDownloadResponseSchema,
} from "@applicant-reviewer/api";

/**
 * useManagerMedia
 * Fetches all media items associated with a given application.
 * Calls GET /manager-media?applicationId={applicationId}
 * Requires manager auth (Hourly JWT).
 */
export function useManagerMedia(applicationId: string) {
  return useQuery({
    queryKey: queryKeys.managerMedia.list(applicationId),
    queryFn: async () => {
      const res = await apiClient.get(
        `/manager-media?applicationId=${encodeURIComponent(applicationId)}`,
        ManagerMediaListResponseSchema,
      );
      return res.items;
    },
    enabled: Boolean(applicationId),
  });
}

/**
 * useManagerMediaDownload
 * Fetches a presigned download URL for a specific media item.
 * Calls GET /manager-media/{mediaId}
 * Requires manager auth (Hourly JWT).
 */
export function useManagerMediaDownload(mediaId: string) {
  return useQuery({
    queryKey: queryKeys.managerMedia.detail(mediaId),
    queryFn: () =>
      apiClient.get(
        `/manager-media/${encodeURIComponent(mediaId)}`,
        ManagerMediaDownloadResponseSchema,
      ),
    enabled: Boolean(mediaId),
  });
}
